import React from "react";
import { hexToRgba } from "../../design-tokens";
import { SynopticTrend } from "../../services/ProductionApi";
import styles from "./ReportSynoptic.module.css";

export interface SynopticTileProps {
  icon: string;
  /** Cor de destaque (hex do token) para o ícone. */
  accent: string;
  label: string;
  value: string;
  unit?: string;
  /** Linha de contexto (meta, delta, atingimento…). */
  sub?: React.ReactNode;
  /** Direção da tendência; omitido → sem chip (ex.: ocupação, que não tem tendência). */
  trend?: SynopticTrend;
  /** true quando valor MAIOR é melhor (produção); false quando MENOR é melhor (ciclo/permanência). */
  higherBetter?: boolean;
  /** Título acessível do chip de tendência (direção). */
  trendTitle?: string;
  /** Classe extra na raiz (ex.: span da grade). */
  className?: string;
}

const arrowFor = (trend: SynopticTrend): string => {
  switch (trend) {
    case "Up":
      return "trending_up";
    case "Down":
      return "trending_down";
    case "Flat":
      return "trending_flat";
    default:
      return "remove";
  }
};

const SynopticTile: React.FC<SynopticTileProps> = ({
  icon,
  accent,
  label,
  value,
  unit,
  sub,
  trend,
  higherBetter,
  trendTitle,
  className,
}) => {
  const good = (trend === "Up" && higherBetter) || (trend === "Down" && !higherBetter);
  const bad = (trend === "Up" && !higherBetter) || (trend === "Down" && higherBetter);
  const chipClass =
    trend === "None"
      ? styles.trendNone
      : good
        ? styles.trendGood
        : bad
          ? styles.trendBad
          : styles.trendFlat;

  return (
    <div className={`${styles.tile} ${className ?? ""}`}>
      <div className={styles.tileHead}>
        <span className={styles.tileIcon} style={{ background: hexToRgba(accent, 0.14), color: accent }}>
          <span className="material-symbols-outlined">{icon}</span>
        </span>
        <span className={styles.tileLabel}>{label}</span>
        {trend != null && (
          <span className={`${styles.trendChip} ${chipClass}`} title={trendTitle} aria-label={trendTitle}>
            <span className="material-symbols-outlined">{arrowFor(trend)}</span>
          </span>
        )}
      </div>
      <div className={styles.tileValueRow}>
        <span className={styles.tileValue}>{value}</span>
        {unit && <span className={styles.tileUnit}>{unit}</span>}
      </div>
      {sub != null && <div className={styles.tileSub}>{sub}</div>}
    </div>
  );
};

export default SynopticTile;
